/**
 * Toast Module
 * Wyświetlanie powiadomień toast z animacjami
 *
 * API:
 *   Toast.show({
 *     title: '+2 Punkty Camel',
 *     text: 'Brawo! Zdobywasz <strong>2 Punkty Camel</strong>!',
 *     duration: 3000       // opcjonalne, default 3000ms
 *   });
 *
 *   // Wariant dynamicznego wyzwania (niebieski, ikona pomocy, CTA, zamykanie)
 *   Toast.show({
 *     variant: 'challenge',
 *     title: 'Chcesz więcej punktów?',
 *     text: 'Zarejestruj <strong>20 kodów</strong> ...',
 *     cta: { label: 'Sprawdź szczegóły', href: 'graj-dynamiczne.html' }, // lub onClick
 *     persistent: true     // bez auto-dismiss (domyślnie dla 'challenge')
 *   });
 */

(function () {
    'use strict';

    var currentToast = null;
    var dismissTimer = null;

    /**
     * Utwórz element DOM toasta
     */
    function createToastElement(options) {
        var isChallenge = options.variant === 'challenge';

        var wrapper = document.createElement('div');
        wrapper.className = 'toast' + (isChallenge ? ' toast--challenge' : '');
        wrapper.setAttribute('role', 'status');
        wrapper.setAttribute('aria-live', 'polite');

        var inner = document.createElement('div');
        inner.className = 'toast__inner';

        // Ikona
        var icon = document.createElement('span');
        icon.className = 'toast__icon';
        icon.setAttribute('aria-hidden', 'true');
        inner.appendChild(icon);

        // Content
        var content = document.createElement('div');
        content.className = 'toast__content';

        if (options.title) {
            var title = document.createElement('p');
            title.className = 'toast__title';
            title.textContent = options.title;
            content.appendChild(title);
        }

        if (options.text) {
            var text = document.createElement('p');
            text.className = 'toast__text';
            text.innerHTML = options.text;
            content.appendChild(text);
        }

        // CTA (opcjonalne) — btn-secondary-negative (biały obrys)
        if (options.cta && options.cta.label) {
            var cta = document.createElement(options.cta.href ? 'a' : 'button');
            cta.className = 'btn btn-secondary-negative btn-sm toast__cta';
            cta.textContent = options.cta.label;
            if (options.cta.href) {
                cta.href = options.cta.href;
            } else {
                cta.type = 'button';
            }
            cta.addEventListener('click', function () {
                if (typeof options.cta.onClick === 'function') {
                    options.cta.onClick();
                }
                if (!options.cta.href) {
                    dismiss(wrapper);
                }
            });
            content.appendChild(cta);
        }

        inner.appendChild(content);

        // Przycisk zamknięcia (domyślnie dla 'challenge' lub gdy closable: true)
        if (options.closable === true || (isChallenge && options.closable !== false)) {
            var closeBtn = document.createElement('button');
            closeBtn.type = 'button';
            closeBtn.className = 'toast__close';
            closeBtn.setAttribute('aria-label', 'Zamknij');
            closeBtn.addEventListener('click', function () {
                dismiss(wrapper);
            });
            inner.appendChild(closeBtn);
        }

        wrapper.appendChild(inner);

        return wrapper;
    }

    /**
     * Usuń toasta z DOM
     */
    function removeToast(el) {
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
        if (currentToast === el) {
            currentToast = null;
        }
    }

    /**
     * Ukryj toasta z animacją dismiss
     */
    function dismiss(el) {
        if (!el) return;

        if (dismissTimer) {
            clearTimeout(dismissTimer);
            dismissTimer = null;
        }

        el.classList.remove('is-visible');
        el.classList.add('is-dismissing');

        var inner = el.querySelector('.toast__inner');
        if (inner) {
            inner.addEventListener('animationend', function handler() {
                inner.removeEventListener('animationend', handler);
                removeToast(el);
            });
        } else {
            removeToast(el);
        }
    }

    /**
     * Pokaż toast
     * @param {Object} options
     * @param {string} options.title  — nagłówek (np. '+2 Punkty Camel')
     * @param {string} options.text   — tekst HTML (np. 'Brawo! Zdobywasz <strong>2 Punkty Camel</strong>!')
     * @param {number} [options.duration=3000] — czas wyświetlania w ms
     */
    function show(options) {
        if (!options) return;

        // Singleton — usuń poprzedni toast natychmiast
        if (currentToast) {
            if (dismissTimer) {
                clearTimeout(dismissTimer);
                dismissTimer = null;
            }
            removeToast(currentToast);
        }

        var duration = options.duration || 3000;
        var el = createToastElement(options);

        document.body.appendChild(el);
        currentToast = el;

        // Trigger reflow before adding class (force animation restart)
        void el.offsetHeight;

        el.classList.add('is-visible');

        // Auto-dismiss po duration (pomijany dla persistent; 'challenge' domyślnie persistent)
        var persistent = options.persistent === true || (options.variant === 'challenge' && options.persistent !== false);
        if (!persistent) {
            dismissTimer = setTimeout(function () {
                dismiss(el);
            }, duration);
        }
    }

    // Globalne API
    window.Toast = {
        show: show,
        dismiss: function () {
            if (currentToast) {
                dismiss(currentToast);
            }
        }
    };
})();
